import dayjs from 'dayjs';
import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import Buttons from '../components/Buttons';
import images from '../config/images';
import { useEffect, useRef } from "react";

const Container = styled.div`
    width: ${props => props.theme.scale * 918}px;
    height: 100%;
    position: relative;
`;

const ScrollContainer = styled.div`
    height: 100%;
    width: 100%;
    overflow-y: scroll;
`;

const List = styled.div`
    display: table;
    width: 100%;
    > div:nth-child(even) {
        background-color: #FAFAFA;
    }
`

const Line = styled.div`
    display: table-row;
    width: 100%;
`;

const Bus = styled.div`
    font-size: ${props => props.theme.scale * 32}px;
    font-family: 'MuseoSans-900';
    text-align: left;
    color: ${props => props.theme.black};
    display: table-cell;
    vertical-align: middle;
    height: ${props => props.theme.scale * 98}px;
    padding: 0 ${props => props.theme.scale * 20}px;
`;

const Direction = styled.div`
    font-size: ${props => props.theme.scale * 24}px;
    font-family: 'MuseoSans-300';
    color: ${props => props.theme.black};
    display: table-cell;
    vertical-align: middle;
    height: ${props => props.theme.scale * 98}px;
`;

const Planned = styled.div`
    font-size: ${props => props.theme.scale * 32}px;
    font-family: 'MuseoSans-900';
    text-align: center;
    color: ${props => props.theme.black};
    display: table-cell;
    vertical-align: middle;
    height: ${props => props.theme.scale * 98}px;
`;

/*
const Expected = styled.div`
    font-size: ${props => props.theme.scale * 32}px;
    font-family: 'MuseoSans-900';
    text-align: center;
    color: ${props => props.theme.shade1};
    display: table-cell;
    vertical-align: middle;
    height: ${props => props.theme.scale * 98}px;
`;
*/

const ListHead = styled.div`
    display: table-row;
    background: black;
    width: 100%;
`;

const BusHead = styled.div`
    font-size: ${props => props.theme.scale * 22}px;
    font-family: 'MuseoSans-300';
    text-align: left;
    color: ${props => props.theme.white};
    display: table-cell;
    vertical-align: middle;
    height: ${props => props.theme.scale * 98}px;
    text-transform: uppercase;
    width: ${props => props.theme.scale * 100}px;
    padding: 0 ${props => props.theme.scale * 20}px;
`;

const DirectionHead = styled.div`
    font-size: ${props => props.theme.scale * 22}px;
    font-family: 'MuseoSans-300';
    color: ${props => props.theme.white};
    display: table-cell;
    vertical-align: middle;
    height: ${props => props.theme.scale * 98}px;
    text-transform: uppercase;
    width: ${props => props.theme.scale * 588}px;
`;

const PlannedHead = styled.div`
    font-size: ${props => props.theme.scale * 22}px;
    font-family: 'MuseoSans-300';
    text-align: center;
    color: ${props => props.theme.white};
    display: table-cell;
    vertical-align: middle;
    height: ${props => props.theme.scale * 98}px;
    text-transform: uppercase;
`;

const ExpectedHead = styled.div`
    font-size: ${props => props.theme.scale * 22}px;
    font-family: 'MuseoSans-300';
    text-align: center;
    color: ${props => props.theme.white};
    display: table-cell;
    vertical-align: middle;
    height: ${props => props.theme.scale * 98}px;
    text-transform: uppercase;
`;

const Error = styled.div`
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    top: ${props => props.theme.scale * 130}px;
    left: ${props => props.theme.scale * 0}px;
    padding-left: ${props => props.theme.scale * 20}px;
`;

const ErrorTitle = styled.div`
    font-size: ${props => props.theme.scale * 26}px;
    font-family: 'MuseoSans-900';
`;

const ErrorUrl = styled.div`
    font-size: ${props => props.theme.scale * 22}px;
    font-family: 'MuseoSans-300';
`;

const Placeholder = styled.img`
    position: absolute;
    top: ${props => props.theme.scale * 0}px;
    right: ${props => props.theme.scale * 40}px;
    width: ${props => props.theme.scale * 200}px;
`;

const ErrorContent = () => {
    return (
        <Container>
            <ScrollContainer>
                <List>
                    <ListHead>
                        <BusHead>Ligne</BusHead>
                        <DirectionHead>Destination</DirectionHead>
                        <PlannedHead>Départ</PlannedHead>
                    </ListHead>
                    <Error>
                        <ErrorTitle>Donnée momentanement indisponible</ErrorTitle>
                        <ErrorUrl>mobilitéit.lu</ErrorUrl>
                        <Placeholder src={images.logos.verkeiersverbond} />
                    </Error>
                </List>
            </ScrollContainer>
            <Buttons type="small" />
        </Container>
    );
}

const MobiliteContent = ({ mobilite }) => {
    const customer = useSelector(state => state.config.customer);
    const location = useSelector(state => state.config.location);
    if (!mobilite) return(null);

    let colorTheme = 'light';

    const now = new Date();
    const hour = now.getHours();

    if (hour <= 6 || hour >= 20) {
        colorTheme = 'dark';
    }

    let iframe = ""
    if (customer === "dudelange" || customer === "diekirch"){
        if (hour <= 6 || hour >= 20) {
            iframe = "https://ng-mobiliteit-api-and-cache.sm4rt.design/busstop/publismart/"+location.name.toUpperCase()+"/"+location.token+"/"+location.id+"/"+location.direction+'/dark';
        }
        else{
            iframe = "https://ng-mobiliteit-api-and-cache.sm4rt.design/busstop/publismart/"+location.name.toUpperCase()+"/"+location.token+"/"+location.id+"/"+location.direction;
        }
    }
    else{
        if (hour <= 6 || hour >= 20) {
            iframe = "https://ng-mobiliteit-api-and-cache.sm4rt.design/busstop/publismart/NG/456fdffsdihlfahdskvalkv98s65d/"+location.id+"/"+location.direction+'/dark';
        }
        else{
            iframe = "https://ng-mobiliteit-api-and-cache.sm4rt.design/busstop/publismart/NG/456fdffsdihlfahdskvalkv98s65d/"+location.id+"/"+location.direction;
        }
    }

    return (
        <Container>
            <ScrollContainer>
                <List>
                    <iframe
                          src={iframe}
                          title="Landing"
                          style={{ width: "100%", height: "100vh", border: 0, display: "block" }}
                        />
                </List>
            </ScrollContainer>
        </Container>
    );
}

const Mobilite = () => {
    const mobilite = useSelector(state => state.data.mobilite);

    if (!mobilite) return <ErrorContent />;

    return <MobiliteContent mobilite={mobilite} />
    
}

export default Mobilite;